import { useState, useEffect } from "react";
import { Table, Button, Container, Alert, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function Activate() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchInactiveProducts();
  }, []);

  const fetchInactiveProducts = () => {
    setLoading(true);
    fetch("http://localhost:4000/products/all")
      .then((res) => res.json())
      .then((data) => {
        // Filter only inactive products
        const inactiveProducts = data.filter(product => !product.isActive);
        setProducts(inactiveProducts);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
        setLoading(false);
        Swal.fire("Error", "Failed to fetch products", "error");
      });
  };

  const handleActivate = (productId, productName) => {
    Swal.fire({
      title: "Activate Product?",
      text: `This will activate "${productName}" and make it visible to customers.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, activate it!",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`http://localhost:4000/products/${productId}/activate`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({}),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data === true) {
              Swal.fire("Activated!", "Product has been activated.", "success");
              fetchInactiveProducts(); // Refresh the list
            } else {
              Swal.fire("Error", "Failed to activate product", "error");
            }
          })
          .catch((error) => {
            console.error("Error activating product:", error);
            Swal.fire("Error", "Failed to activate product", "error");
          });
      }
    });
  };

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Activate Products</h1>
        <Button variant="secondary" onClick={() => navigate("/admin")}>
          Back to Admin
        </Button>
      </div>

      {loading ? (
        <Alert variant="info">Loading inactive products...</Alert>
      ) : products.length === 0 ? (
        <Alert variant="success">
          <strong>Great!</strong> All products are currently active. No inactive products found.
        </Alert>
      ) : (
        <>
          <Alert variant="info">
            <strong>Note:</strong> Activating a product will make it visible to customers and available for purchase.
          </Alert>

          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Product Name</th>
                <th>Description</th>
                <th>Price</th>
                <th>Status</th>
                <th>Created On</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product) => (
                <tr key={product._id}>
                  <td>{product.name}</td>
                  <td>{product.description}</td>
                  <td>₱{product.price}</td>
                  <td>
                    <Badge bg="secondary">Inactive</Badge>
                  </td>
                  <td>{new Date(product.createdOn).toLocaleDateString()}</td>
                  <td>
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => handleActivate(product._id, product.name)}
                    >
                      Activate
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </Container>
  );
}